import { useMutation } from "react-query";
import { saveActivity } from "../../services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";

const useSaveActivity = (params:{onSuccess:(result:ResponseType<any>)=>void,onError:(result:any)=>void})=>{
     return useMutation(saveActivity,params)
}

export default useSaveActivity